import { Link } from 'react-router-dom';
import ScrollReveal from './ScrollReveal';
import { Phone, Mail, MapPin, ArrowUpRight, Globe } from 'lucide-react';

const quickLinks = [
  { label: 'Home', path: '/' },
  { label: 'Surf Packages', path: '/packages' },
  { label: 'Rooms', path: '/rooms' },
  { label: 'Activities', path: '/activities' },
  { label: 'Blog', path: '/blog' },
  { label: 'Store', path: '/store' },
];

const socialLinks = [
  { icon: Globe, label: 'Instagram', href: 'https://www.instagram.com/sablebeachtamraght/' },
  { icon: Phone, label: 'WhatsApp', href: 'https://wa.me/212604689422' },
  { icon: Mail, label: 'Email', href: 'mailto:contact@sablebeachsurfcamp.com' },
];

export default function Footer() {


  return (
    <footer id="contact" className="bg-dark-blue text-white mt-auto">
      {/* Footer content */}
      <div className="pt-16 pb-8 px-6 md:px-12 lg:px-20">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
            {/* About */}
            <div className="lg:col-span-2">
              <div className="flex items-center gap-2 mb-4">
                <img loading="lazy" src="/images/logo_sable_white.webp" alt="Sable Beach Logo" className="h-12 w-auto object-contain" />
              </div>
              <p className="font-body text-white/70 leading-relaxed max-w-md mb-6">
                A surf camp & hostel in the heart of Tamraght, Morocco. We bring together 
                surfers, travelers, and free spirits from around the world in a vibrant 
                community by the sea.
              </p>
              <div className="flex items-center gap-2 text-white/70">
                <MapPin className="w-4 h-4" />
                <span className="font-body text-sm">Tamraght, Agadir, Morocco</span>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="font-heading text-base text-white mb-6">Quick Links</h3>
              <ul className="space-y-3">
                {quickLinks.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="font-body text-white/70 hover:text-ocean-200 transition-colors duration-300 
                                 flex items-center gap-1 group"
                    >
                      {link.label}
                      <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
                    </Link>
                  </li>
                ))}
                <li>
                  <Link
                    to="/contact"
                    className="font-body text-white/70 hover:text-ocean-200 transition-colors duration-300 
                               flex items-center gap-1 group"
                  >
                    Contact
                    <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
                  </Link>
                </li>
              </ul>
            </div>

            {/* Connect */}
            <div>
              <h3 className="font-heading text-base text-white mb-6">Connect</h3>
              <ul className="space-y-3">
                {socialLinks.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="font-body text-white/70 hover:text-ocean-200 transition-colors duration-300 
                                 flex items-center gap-3 group"
                    >
                      <link.icon className="w-5 h-5" />
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Divider + Copyright */}
          <div className="border-t border-white/10 pt-8 mt-12">
            <div className="flex flex-col md:flex-row items-center justify-between gap-6">
              <div className="flex items-center gap-4 text-sm font-body text-white/70">
                <Link to="/terms" className="hover:text-ocean-200 transition-colors">Terms & Conditions</Link>
                <span className="text-white/70">|</span>
                <Link to="/faq" className="hover:text-ocean-200 transition-colors">FAQs</Link>
              </div>
              <div className="flex flex-col md:flex-row items-center gap-4 md:gap-8">
                <p className="font-body text-sm text-white/70 text-center md:text-right">
                  © {new Date().getFullYear()} Sable Beach. All rights reserved.
                </p>
                <p className="font-body text-sm text-white/70 hidden md:block">
                  Made with 🌊 in Tamraght, Morocco
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
